import React, { useEffect, useState } from "react";
import { HashRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Banner1 from "./components/Banner1";
import Banner from "./components/Banner";
import Offers from "./components/Offers";
import Models from "./components/Models";
import Showroom from "./components/Showroom";
import ContactUs from "./components/ContactUs";
import GalleryCarousel from "./components/GalleryCarousel";
import UttamNagarShowroom from "./components/UttamNagarShowroom";
import JanakpuriShowroom from "./components/JanakpuriShowroom";
import BackgroundImg from "./assets/background.jpg"; 
import Footer from "./components/Footer";
import FloatingButtons from "./components/FloatingButtons";
import YamahaLogo from "./assets/yamaha-logo.png";
import SEO from "./components/SEO";

const App = () => {
  const [loading, setLoading] = useState(true);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Detect search engine bots to instantly load content
    const botPattern = /bot|googlebot|crawler|spider|robot|crawling|lighthouse/i;
    const isBot = botPattern.test(navigator.userAgent);

    if (isBot) {
      setLoading(false);
    } else {
      const timer = setTimeout(() => setLoading(false), 1200); // 1.2s loading for users
      return () => clearTimeout(timer);
    }
  }, []);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 640);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  // Multi-location JSON-LD local business structured schema markup
  const homeSchema = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "AutoDealer",
        "@id": "https://excellentmotors.in/#pitampura",
        "name": "Excellent Yamaha Showroom - Pitampura",
        "image": "https://excellentmotors.in/favicon.png",
        "telephone": "+91 7838736859",
        "url": "https://excellentmotors.in",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "HOUSE NO-303, Block B, Saraswati Vihar, Pitampura",
          "addressLocality": "New Delhi",
          "addressRegion": "Delhi",
          "postalCode": "110034",
          "addressCountry": "IN"
        }
      },
      {
        "@type": "AutoDealer",
        "@id": "https://excellentmotors.in/#paschimvihar",
        "name": "Excellent Yamaha Showroom - Paschim Vihar",
        "image": "https://excellentmotors.in/favicon.png",
        "telephone": "+91 7982920138",
        "url": "https://excellentmotors.in",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "RR-11, near Peeragarhi metro station, Block A 2, Mianwali Nagar, Paschim Vihar",
          "addressLocality": "New Delhi",
          "addressRegion": "Delhi",
          "postalCode": "110087",
          "addressCountry": "IN"
        }
      },
      {
        "@type": "AutoDealer",
        "@id": "https://excellentmotors.in/#peeragarhishowroom",
        "name": "Excellent Yamaha Showroom - Peeragarhi Village",
        "image": "https://excellentmotors.in/favicon.png",
        "telephone": "+91 8447347239",
        "url": "https://excellentmotors.in",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "487/37, near Sidh baba mandir, Peera Garhi, Peeragarhi Village, Paschim Vihar",
          "addressLocality": "New Delhi",
          "addressRegion": "Delhi",
          "postalCode": "110087",
          "addressCountry": "IN"
        }
      },
      {
        "@type": "AutoDealer",
        "@id": "https://excellentmotors.in/#rithala",
        "name": "Excellent Yamaha Showroom - Rithala",
        "image": "https://excellentmotors.in/favicon.png",
        "telephone": "+91 8368321512",
        "url": "https://excellentmotors.in",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Khasra no.-132, near devi mata mandir, Rithala Extension, Rithala, Rohini",
          "addressLocality": "New Delhi",
          "addressRegion": "Delhi",
          "postalCode": "110085",
          "addressCountry": "IN"
        }
      }
    ]
  };

  const offersSchema = {
    "@context": "https://schema.org",
    "@type": "SpecialAnnouncement",
    "name": "Excellent Yamaha Exclusive Offers & Low Down Payment Schemes",
    "description": "Book a Yamaha motorcycle with down payment starting from Rs 15,000 or scooter from Rs 10,000. Limited period offers across Delhi showrooms.",
    "url": "https://excellentmotors.in/offers",
    "category": "Dealership Offers"
  };

  const modelsSchema = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    "name": "Yamaha Bikes and Scooters Inventory at Excellent Yamaha",
    "description": "Full lineup of Yamaha motorcycles including R3, R15M, R15 V4, MT-03, MT-15, FZ-S, and scooters including Aerox 155, Fascino, RayZR.",
    "url": "https://excellentmotors.in/models",
    "numberOfItems": 15,
    "itemListElement": [
      { "@type": "ListItem", "position": 1, "name": "Yamaha R3" },
      { "@type": "ListItem", "position": 2, "name": "Yamaha R15M" },
      { "@type": "ListItem", "position": 3, "name": "Yamaha R15 V4" },
      { "@type": "ListItem", "position": 4, "name": "Yamaha MT-15 Ver 2.0" },
      { "@type": "ListItem", "position": 5, "name": "Yamaha Aerox 155" }
    ]
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-blue-900">
        <style>{`
@keyframes zoomIn {
  0% { transform: scale(0.5); opacity: 0; }
  100% { transform: scale(1); opacity: 1; }
}
.animate-zoomIn { animation: zoomIn 0.8s; }
@keyframes fadeIn {
  0% { opacity: 0; }
  100% { opacity: 1; }
}
.animate-fadeIn { animation: fadeIn 1s; }
@keyframes spin {
  to { transform: rotate(360deg); }
}
`}</style>
          <div className="flex flex-col items-center animate-fadeIn">
            <img
              src={YamahaLogo}
              alt="Yamaha Logo"
              className="w-40 h-40 mb-6 animate-zoomIn drop-shadow-lg"
              style={{ animation: "zoomIn 0.8s" }}
            />
            <div className="w-12 h-12 border-4 border-white border-t-blue-400 rounded-full mb-6" style={{ animation: 'spin 0.5s linear infinite' }}></div>
            <span className="text-4xl font-extrabold text-white tracking-wide animate-fadeIn drop-shadow mb-2">Excellent Motors</span>
          </div>
      </div>
    );
  }

  return (
    <Router>
      <div className="bg-cover bg-center bg-gray-50 text-gray-900">
        <Header />
        
        <Routes>
          {/* HOME ROUTE */}
          <Route path="/" element={
            <>
              <SEO 
                title="Authorized Yamaha Bike and Scooter Showroom in Delhi" 
                description="Excellent Motors is your authorized Yamaha dealer in West Delhi, Rohini, and Peeragarhi. Book your R15, MT-15, FZ-S, or Aerox 155 today with down payments starting at ₹15,999!"
                keywords="Yamaha showroom near me, Yamaha dealer Delhi, Yamaha Saraswati Vihar, Yamaha Peeragarhi, Yamaha Rohini, Yamaha Pitampura, Yamaha R15 Delhi"
                canonical="https://excellentmotors.in"
                schema={homeSchema}
              />
              {isMobile ? <Banner1 /> : <Banner />}
              <Offers />
              
              {/* Embedded Offers Section */}
              <section className="py-6">
                <div className="grid grid-cols-1 md:grid-cols-2 items-center" style={{ backgroundImage: `url(${BackgroundImg})`}}>
                  <div className="animate-slideInLeft">
                    <img
                      src="/images/yamaha_offers2.jpg"
                      alt="Exclusive Yamaha Offers Special Schemes"
                      className="w-full h-full shadow-md"
                    />
                  </div>
                  <div className="animate-slideInLeft delay-200">
                    <img
                      src="/images/yamaha_offers3.jpg"
                      alt="Yamaha Festival Discount Scheme Banner"
                      className="w-full h-auto shadow-md"
                    />
                  </div>
                </div>
              </section>

              <Models />
              <GalleryCarousel />
              <Showroom />
              <ContactUs />
            </>
          } />

          {/* OFFERS ROUTE */}
          <Route path="/offers" element={
            <div className="pt-20">
              <SEO 
                title="Exclusive Yamaha Deals & Finance Offers" 
                description="Grab hot deals and easy finance schemes on all Yamaha bikes and scooters. Exchange bonus, down payment from ₹15,999, and corporate benefits in Delhi!" 
                keywords="Yamaha offers Delhi, Yamaha down payment offers, Yamaha bike loan Delhi, Fascino discounts, MT-15 schemes"
                canonical="https://excellentmotors.in/offers"
                schema={offersSchema}
              />
              <Offers />
              <section className="py-6">
                <div className="grid grid-cols-1 md:grid-cols-2 items-center" style={{ backgroundImage: `url(${BackgroundImg})`}}>
                  <div className="animate-slideInLeft">
                    <img
                      src="/images/yamaha_offers2.jpg"
                      alt="Yamaha MT-15 and FZ Finance Offers"
                      className="w-full h-full shadow-md"
                    />
                  </div>
                  <div className="animate-slideInLeft delay-200">
                    <img
                      src="/images/yamaha_offers3.jpg"
                      alt="Yamaha Scooter Exchange Deals Delhi"
                      className="w-full h-auto shadow-md"
                    />
                  </div>
                </div>
              </section>
            </div>
          } />

          {/* MODELS ROUTE */}
          <Route path="/models" element={
            <div className="pt-20">
              <SEO 
                title="Latest Yamaha Motorcycles & Scooters Lineup" 
                description="Check prices, specs, and availability for Yamaha R15 V4, MT-15 V2, FZ-S FI, Aerox 155, RayZR, and Fascino 125 at Excellent Motors showrooms." 
                keywords="Yamaha R15 V4 price Delhi, Yamaha MT-15 price, Yamaha Aerox showroom, Yamaha scooter range Delhi, Yamaha inventory"
                canonical="https://excellentmotors.in/models"
                schema={modelsSchema}
              />
              <Models />
            </div>
          } />

          {/* SHOWROOM / LOCATE US ROUTE */}
          <Route path="/locate-us" element={
            <div className="pt-20">
              <SEO 
                title="Our Showroom Branches in Delhi - Saraswati Vihar, Peeragarhi, Rohini" 
                description="Visit Excellent Motors authorized Yamaha showrooms in Delhi NCR. Get directions, contact phone numbers, and check showroom timings for our 4 convenient branches." 
                keywords="Yamaha showroom West Delhi, Yamaha showroom Pitampura, Yamaha showroom Paschim Vihar, Yamaha Rithala showroom, Yamaha directions"
                canonical="https://excellentmotors.in/locate-us"
                schema={homeSchema}
              />
              <Showroom />
            </div>
          } />

          {/* CONTACT ROUTE */}
          <Route path="/contact" element={
            <div className="pt-20">
              <SEO 
                title="Book a Free Yamaha Test Ride - Contact Excellent Motors" 
                description="Get in touch with our representative or schedule a test ride. Fill out our contact form, call +91-7838736859, or chat via WhatsApp." 
                keywords="Book Yamaha test ride Delhi, Yamaha contact number, Yamaha showroom Peeragarhi phone, Excellent Motors feedback"
                canonical="https://excellentmotors.in/contact"
              />
              <ContactUs />
            </div>
          } />

          {/* UTTAM NAGAR SEO LANDING ROUTE */}
          <Route path="/yamaha-showroom-uttam-nagar" element={<UttamNagarShowroom />} />

          {/* JANAKPURI SEO LANDING ROUTE */}
          <Route path="/yamaha-showroom-janakpuri" element={<JanakpuriShowroom />} />
        </Routes>

        <FloatingButtons />
        <Footer />
      </div>
    </Router>
  );
}

export default App;
